import MaterialEditor from './MaterialEditor'

export default MaterialEditor
